import moment from "moment";
import Divider from "@material-ui/core/Divider";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { instance } from "../../../Actions/AxiosInstance";
import { DateConversion } from "../../../Utils/dates";
import CheckImg from "../../../Assets/Images/check.png";
import designationIcon from "../../../Assets/Icons/Designation/designation-16px.svg";
import departmentIcon from "../../../Assets/Icons/Department/department-16px.svg";
import calenderIcon from "../../../Assets/Icons/Calendar/calendar-16px.svg";
import cake from "../../../Assets/Icons/Cake/outline/cake-outline-16px.svg";
import CustomLoader from "Component/CustomLoader";
import Dialog from "@material-ui/core/Dialog";

import If from "../../../Component/Common/If";
import createstore from "../../../store";
import Copier from "./copier.js";
import "./directory.css";
import Email from "./Email.js";
import {
  getFormattedImageLink,
  convertDateForBackend,
  getFormattedDate,
  rawDataIntoExcel,
} from "../../../Utils";
import Tooltip from "@material-ui/core/Tooltip";
import { FEATUREKEYS } from "../../../Constants/Featurekeys";
import defaultstateimg from "../../../Assets/Svg/group-5.svg";
import DefaultComp from "../../../Component/DefaultComp/Defaultstatecomp";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
});

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link"], // 'image'
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  // "image"
];

class EmpDirectoryDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectAllFlag: this.props.SelectAllFlag,
      selectedFilter: this.props.selectedFilter,
      rowsPerPage: this.props.rowsPerPage,
      offset: this.props.offset,
      isteammember: this.props.isteammember,
      isExport: this.props.isExport,
      allEmployeeList: [],
      DateFormat: "",
      isSelected: false,
      SelectedProfiles: [],
      copyText: "",
      copied: false,
      value: 0,
      expanded: false,
      // port: window.location.port,
      open: false,
      animation: false,
      datareceived: false,
    };

    this.ExportData = this.ExportData.bind(this);
    this.sendMailToEmployee = this.sendMailToEmployee.bind(this);
  }

  doAnimation = () => {
    this.setState({
      animation: !this.state.animation,
    });
  };

  componentWillReceiveProps(props, prevprops) {
    if (typeof props.SelectAllFlag === "boolean") {
      if (props.SelectAllFlag) {
        this.updateAllFlag(true);
      } else {
        this.updateAllFlag(false);
      }
    }

    if (props.getEmpList == true) {
      let isteammember;
      props.isteammember == true
        ? (isteammember = true)
        : (isteammember = false);
      this.setState(
        {
          rowsPerPage: props.rowsPerPage,
          offset: props.offset,
          isteammember,
          allEmployeeList: props.offset == 0 ? [] : this.state.allEmployeeList,
        },
        () => {
          this.GetAllEmployeeList();
        },
      );
    }
    // else {
    //   this.setState({ allEmployeeList: [] })
    // }

    if (props.isExport == true) {
      this.ExportData();
    }

    if (props.isSendMail == true && props.expandClose) {
      this.sendMailToEmployee();
      // props.sendMail(false,true)
    }
  }

  sendMailToEmployee() {
    // this.props.sendMail(false)

    if (this.state.SelectedProfiles.length == 0) {
      this.props.enqueueSnackbar("Please select at-least one employee", {
        variant: "error",
      });
      this.props.sendMail(false, false);
      return false;
    }

    if (!this.props.mailbody) {
      this.props.enqueueSnackbar("Please add message", { variant: "error" });
      this.props.sendMail(false, false);
      return false;
    }
    const recipientemailids = [];
    for (const emp of this.state.SelectedProfiles) {
      const empdata = this.state.allEmployeeList.find(
        (x) => x.employeeid == emp,
      );
      recipientemailids.push(empdata.emailid);
    }
    const { AuthenticationAction } = createstore.getState();
    const data = {
      templetcode: "101", // Temporary
      senderemail: "temp", // Temporary
      recipientemployeeids: this.state.SelectedProfiles,
      attachmentname: null,
      replytoemail: null,
      ccemail: null,
      bccemail: null,
      priorityid: null,
      recipientemailids,
      mailbody: this.props.mailbody,
      subject: `${AuthenticationAction.login.fullname} has sent you a message!`,
    };
    instance
      .post("subscription/directorymail", data)
      .then((result) => {
        // this.setState({ SelectedProfiles: [] })
        this.props.enqueueSnackbar("Notification sent successfully", {
          variant: "success",
        });
        this.props.sendMail(false, true);
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  componentWillMount() {
    this.GetAllEmployeeList();
    // let AuthenticationAction = createstore.getState().AuthenticationAction;
    // let DateFormat = AuthenticationAction.login.dateformat;
    const { SubscriptionInfo } = createstore.getState();
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      " ",
    );
    let ShortDateFormat = DateFormat.split(" ");
    ShortDateFormat = ShortDateFormat[0];
    this.setState({ ShortDateFormat });
  }

  componentDidMount() {}

  convertDate(str) {
    const date = new Date(str);
    const mnth = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  ExportData() {
    const rows = [
      [
        "Employee ID",
        "Full name",
        "Department",
        "Designation",
        "Email ID",
        "Date Of Birth",
        "Date of Joining",
        "Mobile No.",
      ],
    ];
    if (this.state.SelectedProfiles.length > 0) {
      const { allEmployeeList } = this.state;
      for (const profiles of this.state.SelectedProfiles) {
        const profileData = allEmployeeList.find(
          (x) => x.employeeid == profiles,
        );
        // var result = Object.keys(profileData).map(key => [profileData[key]]);
        if (profileData) {
          const employee = [];
          employee.push(profileData.employeecode);
          employee.push(profileData.fullname);
          employee.push(profileData.departmentname);
          employee.push(profileData.designationname);
          employee.push(profileData.emailid);
          employee.push(getFormattedDate(profileData.dob));
          employee.push(getFormattedDate(profileData.doj));
          employee.push(profileData.primarymobile);
          rows.push(employee);
        }
        const index = allEmployeeList.findIndex(
          (y) => y.employeeid == profiles,
        );
        profileData.isSelected = true;
        allEmployeeList[index] = profileData;
        // profileData ? rows.push(Object.keys(profileData).map(key => [profileData[key]])) : null
      }

      this.setState({ allEmployeeList });

      const csvContent = rawDataIntoExcel(rows);

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "my_data.csv");
      document.body.appendChild(link); // Required for FF
      link.click();
      this.props.ExportData(false);
    } else {
      this.props.ExportData(false);
      this.props.enqueueSnackbar("Please select at-least one employee", {
        variant: "error",
      });
    }
  }

  updateAllFlag(flag) {
    let SelectedProfiles = [];

    if (!flag) {
      SelectedProfiles = [];
    }

    for (const employee of this.state.allEmployeeList) {
      employee.isSelected = flag;
      if (flag) {
        SelectedProfiles.push(employee.employeeid);
      }
    }
    this.setState({
      SelectedProfiles,
      allEmployeeList: [...this.state.allEmployeeList],
    });
  }

  GetAllEmployeeList() {
    const URL = "/subscription/subsriptiongetdirectory";
    let filter = [];
    filter = this.props.selectedFilter || [];
    const data = {
      limit: this.state.rowsPerPage,
      offset: this.state.offset,
      filtertypeid: this.props.filterid,
      featurekey: "directory",
    };
    for (const info of filter) {
      if (info.key == "LbFirstName") {
        Object.assign(data, { firstname: info.value });
      }
      if (info.key == "LbLastName") {
        Object.assign(data, { lastname: info.value });
      }
      if (info.key == "LbMobileNumber") {
        Object.assign(data, { mobilenumber: info.value });
      }
      if (info.key == "LbMaritalStatus") {
        if (info.value) {
          Object.assign(data, { maritalstatusid: info.value });
        }
      }
      if (info.key == "LbGender") {
        if (info.value) {
          Object.assign(data, { genderid: info.value });
        }
      }
      if (info.key == "LbBloodGroup") {
        if (info.value) {
          Object.assign(data, { bloodgroupid: info.value });
        }
      }
      if (info.key == "LbOfficeLocation") {
        if (info.value) {
          Object.assign(data, { officeaddressid: info.value });
        }
      }
      if (info.key == "LbBU") {
        if (info.value) {
          Object.assign(data, { businessunitid: info.value });
        }
      }
      if (info.key == "LbTeam") {
        if (info.value) {
          Object.assign(data, { teamid: info.value });
        }
      }
      if (info.key == "LbEmpstatus") {
        if (info.value) {
          Object.assign(data, { employeestatusid: info.value });
        }
      }

      if (info.key == "LbSelfService") {
        console.log("info.value: ", info.value);
        Object.assign(data, { isselfservice: info.value });
      }

      if (info.key == "LbEmpstage") {
        console.log("info.value11: ", info.value);
        Object.assign(data, { stageid: info.value });
      }

      if (info.key == "LbDoJ") {
        if (info.toggle) {
          Object.assign(data, { dojfrom: convertDateForBackend(info.value1) });
          Object.assign(data, {
            dojto: convertDateForBackend(info.value2),
          });
        } else {
          Object.assign(data, { dojfrom: convertDateForBackend(info.value) });
          Object.assign(data, {
            dojto: convertDateForBackend(info.value),
          });
        }
      }
      
      if (info.key == "LbBob") {
        if (info.toggle) {
          Object.assign(data, {
            dobfrom: convertDateForBackend(info.value1),
          });
          Object.assign(data, {
            dobto: convertDateForBackend(info.value2),
          });
        } else {
          const x = moment(info.value).format("MM-DD").split("-");
          Object.assign(data, {
            dobday: x[1],
          });
          Object.assign(data, {
            dobmonth: x[0],
          });
        }
      }
      if (info.key == "LbMarriageAnni") {
        if (info.toggle) {
          Object.assign(data, {
            marriageanniversarydatefrom: convertDateForBackend(info.value1),
          });
          Object.assign(data, {
            marriageanniversarydateto: convertDateForBackend(info.value2),
          });
        } else {
          const x = moment(info.value).format("MM-DD").split("-");
          Object.assign(data, {
            marriageanniversarydateday: x[1],
          });
          Object.assign(data, {
            marriageanniversarydatemonth: x[0],
          });
        }
      }
      if (info.key == "LbNd") {
        if (info.toggle) {
          Object.assign(data, {
            noticefrom: convertDateForBackend(info.value1),
          });
          Object.assign(data, {
            noticeto: convertDateForBackend(info.value2),
          });
        } else {
          Object.assign(data, {
            noticefrom: convertDateForBackend(info.value),
          });
          Object.assign(data, {
            noticeto: convertDateForBackend(info.value),
          });
        }
      }
      if (info.key == "LbEd") {
        if (info.toggle) {
          Object.assign(data, {
            exitfrom: convertDateForBackend(info.value1),
          });
          Object.assign(data, {
            exitto: convertDateForBackend(info.value2),
          });
        } else {
          Object.assign(data, {
            exitfrom: convertDateForBackend(info.value),
          });
          Object.assign(data, {
            exitto: convertDateForBackend(info.value),
          });
        }
      }
      if (info.key == "LbBankname") {
        Object.assign(data, { bankname: info.value });
      }
      if (info.key == "LbTags") {
        Object.assign(data, { tags: info.value });
      }
      if (info.key == "LbEmpDepartment") {
        if (info.value) {
          Object.assign(data, { departmentid: info.value });
        }
      }
      if (info.key == "LbEmptype") {
        if (info.value) {
          Object.assign(data, { employmenttypeid: info.value });
        }
      }
      if (info.key == "LbManagerTeam") {
        if (info.value) {
          Object.assign(data, { managerid: info.value });
        }
      }
    }
    this.setState({ isloading: true }, () => {
      instance
        .post(URL, data)
        .then((result) => {
          // for (let i = 0; i <= 8; i++) {
          //     result.data.result.push(Object.assign(result.data.result[0], { fullcount: 118 }))
          // }
          this.setState({
            datareceived: true,
            isloading: false,
          });
          let allEmployeeList = [];
          let displayRecordCount = "";
          if (
            JSON.stringify(this.state.allEmployeeList) ===
            JSON.stringify(result.data.result)
          ) {
            this.props.getList(
              this.state.allEmployeeList.length,
              result.data.result[0] ? result.data.result[0].fullcount : 0,
            );
            return;
          }
          //  if (result.data.result.length < 1) {
          //   this.props.getList(0, 0);
          //   return;
          // }
          result.data.result.length > 0
            ? (displayRecordCount =
                this.state.allEmployeeList.length + result.data.result.length)
            : (displayRecordCount = this.state.allEmployeeList.length);
          let TotalRecordCount = "";
          result.data.result.length > 0
            ? (allEmployeeList = [
                ...this.state.allEmployeeList,
                ...result.data.result,
              ])
            : (allEmployeeList = this.state.allEmployeeList);
          console.log("result.data.resul: ", result.data.result);
          TotalRecordCount =
            result.data.result.length > 0 ? allEmployeeList[0].fullcount : 0;
          console.log("TotalRecordCount11: ", TotalRecordCount);
          const SelectedProfiles = [];
          if (this.state.SelectAllFlag) {
            for (const employee of allEmployeeList) {
              employee.isSelected = true;
              SelectedProfiles.push(employee.employeeid);
            }
          }
          console.log("here   wsfddsdf");
          this.setState({
            allEmployeeList,
            SelectedProfiles,
            datareceived: true,
          });
          this.props.getList(allEmployeeList.length, TotalRecordCount);
        })
        .catch((error) => {
          this.setState({ isloading: false });
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    });
  }

  RouteToProfile(id, e) {
    const employeeLink = `${window.location.origin}/profile/${id}`;

    window.open(employeeLink, "_blank");
  }

  GetSelectedProfiles(data, e) {
    // let SelectedProfiles = [];
    // SelectedProfiles.push(data.employeeid)
    // let SelectedProfiles = this.state.SelectedProfiles;
    // let allEmployeeList = this.state.allEmployeeList;

    const index = this.state.SelectedProfiles.findIndex(
      (item) => item == data.employeeid,
    );
    const indexEmp = this.state.allEmployeeList.findIndex(
      (item) => item == data.employeeid,
    );

    if (index != -1) {
      data.isSelected = false;
      this.state.SelectedProfiles.splice(index, 1);
    } else {
      data.isSelected = true;
      this.state.SelectedProfiles.push(data.employeeid);
    }
    this.state.allEmployeeList[indexEmp] = data;
    this.setState({
      SelectedProfiles: [...this.state.SelectedProfiles],
      allEmployeeList: [...this.state.allEmployeeList],
    });
  }

  copyToClip(data) {
    const copyText = `Hi,
        Employee Mobile Number ${data.fullname}.
        Employee Email Id ${data.primarymobile}.`;
    this.setState({ copyText });
  }

  handleTooltipClose = () => {
    this.setState({ open: false });
  };

  handleTooltipOpen = () => {
    this.setState({ open: true });
  };

  render() {
    const { classes } = this.props;
    const { value, datareceived } = this.state;

    return (
      <div>
        <Helmet>
          <title>{headersList.Directory.header}</title>
        </Helmet>
        <If condition={datareceived}>
          <div>
            {this.state.allEmployeeList.length != 0 ? (
              this.state.allEmployeeList.map((data) => {
                const copiedText = "";
                const copiedmail = "";
                return (
                  <div key="key">
                    <Grid
                      container
                      className={classNames(
                        "dir-emp-details",
                        "dir-emp-details-main",
                      )}
                    >
                      <Grid
                        item
                        xs={12}
                        md={3}
                        sm={4}
                        className="dir-emp-details-left"
                        style={{ height: "100%" }}
                      >
                        <div className="position-rel">
                          <div
                            // onClick={this.GetSelectedProfiles.bind(this, data)}
                            className={classNames("dir-emp-img")}
                            style={{ paddingTop: 8 }}
                          >
                            <div
                              onClick={this.GetSelectedProfiles.bind(
                                this,
                                data,
                              )}
                              className={classNames("cursour-pointer")}
                              style={{ width: 64 }}
                            >
                              {!data.isSelected ? (
                                <img
                                  className="dir-profile-img"
                                  src={getFormattedImageLink(data.imagepath)}
                                  height="64"
                                />
                              ) : (
                                <img
                                  className="dir-profile-img"
                                  src={CheckImg}
                                  height="64"
                                />
                              )}
                            </div>
                          </div>
                          <div className="dir-emp-info2">
                            <span
                              className={classNames(
                                "cursour-pointer",
                                "no-padding",
                                "name-required-width",
                              )}
                              onClick={this.RouteToProfile.bind(
                                this,
                                data.employeeid,
                              )}
                              style={{
                                display: "block",
                                fontSize: 14,
                                marginTop: 14,
                                width: 180,
                              }}
                            >
                              {data.fullname}
                            </span>
                            <If condition={data.employeecode}>
                              <span
                                style={{
                                  display: "block",
                                  marginTop: 16,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  fontSize: 14,
                                }}
                              >
                                <Tooltip
                                  PopperProps={{
                                    disablePortal: true,
                                  }}
                                  title={data.employeecode}
                                  placement="top"
                                >
                                  <span
                                    className="ellipsis"
                                    style={{
                                      width: 120,
                                      cursor: "default",
                                      fontSize: 14,
                                    }}
                                  >
                                    {/* {data.designationname}  */}
                                    {data.employeecode}
                                  </span>
                                </Tooltip>
                              </span>
                            </If>
                          </div>
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={9}
                        sm={8}
                        style={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "row",
                        }}
                        className="dir-emp-details-right"
                      >
                        <Grid
                          item
                          xs={12}
                          md={12}
                          sm={12}
                          className="dir-emp-details-right1"
                          style={{ maxWidth: "85%" }}
                        >
                          <div
                            style={{
                              display: "table",
                              height: "100%",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                display: "table-cell",
                                verticalAlign: "middle",
                              }}
                            >
                              {data.departmentname ? (
                                <div
                                  className="inlineClass emp-desc empDesName padding-left-10"
                                  // style={{ width: 200 }}
                                  style={{ width: "28%", height:data.doj ? "" : 53 }}
                                >
                                  <span
                                    style={{
                                      float: "left",
                                      height: 16,
                                      marginTop: 1,
                                      marginRight: 6,
                                    }}
                                  >
                                    {/* <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    style={{ width: 16 }}
                                  >
                                    <path d="M0 0h24v24H0z" fill="none" />
                                    <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
                                  </svg> */}
                                    <img src={designationIcon}></img>
                                  </span>
                                  <Tooltip
                                    PopperProps={{
                                      disablePortal: true,
                                    }}
                                    title={data.designationname}
                                    placement="top"
                                  >
                                    <span
                                      className="floatleft ellipsis"
                                      style={{
                                        width: 120,
                                        cursor: "default",
                                        fontSize: 14,
                                      }}
                                    >
                                      {data.designationname}
                                    </span>
                                  </Tooltip>
                                </div>
                              ) : (
                                ""
                              )}
                              <div
                                className="inlineClass empTeam emp-designation"
                                style={{ width: "24%", height:data.doj ? "" : 53 }}
                              >
                                <span
                                  style={{
                                    float: "left",
                                    height: 16,

                                    marginRight: 6,
                                  }}
                                >
                                  <img src={departmentIcon}></img>
                                </span>
                                <Tooltip
                                  PopperProps={{
                                    disablePortal: true,
                                  }}
                                  title={data.departmentname}
                                  placement="top"
                                >
                                  <span
                                    className="floatleft ellipsis"
                                    style={{
                                      width: 120,
                                      cursor: "default",
                                      fontSize: 14,
                                    }}
                                  >
                                    {data.departmentname}
                                  </span>
                                </Tooltip>
                              </div>
                              {data.doj && 
                              <div
                                className="inlineClass empJoiningDate emp-desc padding-left-10"
                                style={{ width: "22%" }}
                              >
                                <span
                                  style={{
                                    float: "left",
                                    height: 16,

                                    marginRight: 6,
                                  }}
                                >
                                  <img src={calenderIcon}></img>
                                </span>
                                <span className="floatleft t-14">
                                  {getFormattedDate(data.doj)}
                                </span>
                              </div>
                              }
                               {data.dob && 
                              <div
                                className="inlineClass emp-desc empBirthDate"
                                style={{ width: "18%" }}
                              >
                               
                                  <React.Fragment>
                                    <span
                                      style={{
                                        float: "left",
                                        height: 16,
                                        marginRight: 6,
                                      }}
                                    >
                                      <img src={cake}></img>
                                    </span>
                                    <span className="floatleft t-14">
                                      {getFormattedDate(data.dob)}
                                    </span>
                                  </React.Fragment>
                                
                              </div>
                              }
                              {!data.doj && !data.dob &&
                              <div
                              className="emp-mob-email-height inlineClass"
                              style={{ height: 80, width:"18%" }}
                            >
                              <div>
                                {data.primarymobile ? <Copier data={data} /> : ""}
                                {/* {data.fburl ? (
                                <span className="dir-emp-links">
                                  <a
                                    href={data.fburl}
                                    target="_blank"
                                    replace="true"
                                    className="social-icon"
                                  >
                                    <svg width="24px" height="24px" viewBox="0 0 22 22" version="1.1">
                                      <g
                                        id="Page-1"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                      >
                                        <g
                                          id="Final-emp_profile_edit-mode"
                                          transform="translate(-183.000000, -454.000000)"
                                        >
                                          <g
                                            id="facebook-logo-in-circular-button-outlined-social-symbol"
                                            transform="translate(183.000000, 454.000000)"
                                            fill="#000000"
                                            fillOpacity="0.38"
                                          >
                                            <path
                                              d="M22,11 C22,4.92498039 17.0749837,0 11,0 C4.92498039,0 0,4.92498039 0,11 C0,17.0749837 4.92498039,22 11,22 C17.0749837,22 22,17.0749837 22,11 Z M0.999993464,11 C0.999993464,5.47699346 5.47699346,0.999993464 11,0.999993464 C16.5230065,0.999993464 21.0000065,5.47699346 21.0000065,11 C21.0000065,16.5230065 16.5230065,21.0000065 11,21.0000065 C5.47699346,21.0000065 0.999993464,16.5230065 0.999993464,11 Z"
                                              id="Shape"
                                              fillRule="nonzero"
                                            />
                                            <path
                                              d="M11.4222101,18 L11.4222101,11.4912845 L13.5458869,11.4912845 L13.8814248,9.33436519 L11.4222101,9.33436519 L11.4222101,8.2528284 C11.4222101,7.69002242 11.6046643,7.15282869 12.4034618,7.15282869 L14,7.15282869 L14,5 L11.7334062,5 C9.82767605,5 9.30764325,6.26911422 9.30764325,8.02832513 L9.30764325,9.33337019 L8,9.33337019 L8,11.4912845 L9.30764325,11.4912845 L9.30764325,18 L11.4222101,18 Z"
                                              id="Path"
                                            />
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                  </a>
                                </span>
                              ) : (
                                  ""
                                )} */}
                                {data.emailid ? <Email data={data} /> : ""}
                                {/* {data.twitterurl ? (
                                <div className="dir-emp-links">
                                  <a
                                    href={data.twitterurl}
                                    target="_blank"
                                    replace="true"
                                    className="social-icon"
                                  >
                                    <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1">
                                      <g
                                        id="Page-1"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                      >
                                        <g
                                          id="Final-emp_profile_edit-mode"
                                          transform="translate(-217.000000, -454.000000)"
                                        >
                                          <g
                                            id="Group-18"
                                            transform="translate(217.000000, 454.000000)"
                                            fill="#000000"
                                            fillOpacity="0.38"
                                          >
                                            <path
                                              d="M16.6764034,9.56177353 C16.6764034,9.46338563 16.674194,9.36588985 16.6687101,9.26928618 C17.1900373,8.95551545 17.642204,8.56288783 18,8.11351512 C17.5214789,8.28725515 17.007845,8.40335797 16.4678567,8.452074 C17.0188128,8.1781937 17.4413506,7.7403548 17.6410993,7.2147697 C17.1252561,7.46736661 16.5545736,7.64817987 15.9476342,7.74213904 C15.4614593,7.29541082 14.7678425,7.01092068 14.0006464,7.00027898 C12.5278005,6.98077983 11.3337268,7.98587849 11.3337268,9.24532644 C11.3337268,9.42435545 11.3567672,9.59809548 11.4028479,9.76559069 C9.18482044,9.65037999 7.21921101,8.7179571 5.90437287,7.31226548 C5.67499522,7.64907199 5.54330231,8.04259172 5.54330231,8.46449993 C5.54330231,9.26221296 6.01413011,9.97125581 6.72968265,10.3895955 C6.2917978,10.3736649 5.88133253,10.2664195 5.52136664,10.0908952 C5.52136664,10.1006448 5.52136664,10.1103944 5.52136664,10.120144 C5.52136664,11.2351643 6.44108659,12.1693396 7.6614751,12.3873669 C7.43758137,12.4387593 7.20161513,12.4653636 6.9590603,12.4645033 C6.78677062,12.4636112 6.6199254,12.4485408 6.45749888,12.4201523 C6.79663378,13.3339681 7.78220018,14.0013682 8.94881475,14.0235118 C8.0356834,14.6350589 6.88552058,15.000222 5.63656835,14.9975775 C5.4214331,14.9975775 5.20854666,14.9860756 5,14.9647922 C6.18093588,15.618906 7.58241201,15.9999998 9.08926615,15.9999998 C13.9940578,16.0009238 16.6764034,12.5531098 16.6764034,9.56177353 Z"
                                              id="Path"
                                            />
                                            <path
                                              d="M22,11 C22,4.92498039 17.0749837,0 11,0 C4.92498039,0 0,4.92498039 0,11 C0,17.0749837 4.92498039,22 11,22 C17.0749837,22 22,17.0749837 22,11 Z M1,11 C1,5.47699707 5.47699707,1 11,1 C16.5230029,1 21,5.47699707 21,11 C21,16.5230029 16.5230029,21 11,21 C5.47699707,21 1,16.5230029 1,11 Z"
                                              id="Shape"
                                              fillRule="nonzero"
                                            />
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                  </a>
                                </div>
                              ) : (
                                  ""
                                )} */}
                              </div>
                            </div>
                              }
                            </div>
                          </div>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={12}
                          sm={12}
                          style={{ maxWidth: "15%" }}
                          className="emp-mob-email-height-outer height-48"
                        >
                          {data.doj && data.dob && 
                          <div
                            className="emp-mob-email-height"
                            style={{ height: 80 }}
                          >
                            <div>
                              {data.primarymobile ? <Copier data={data} /> : ""}
                              {/* {data.fburl ? (
                              <span className="dir-emp-links">
                                <a
                                  href={data.fburl}
                                  target="_blank"
                                  replace="true"
                                  className="social-icon"
                                >
                                  <svg width="24px" height="24px" viewBox="0 0 22 22" version="1.1">
                                    <g
                                      id="Page-1"
                                      stroke="none"
                                      strokeWidth="1"
                                      fill="none"
                                      fillRule="evenodd"
                                    >
                                      <g
                                        id="Final-emp_profile_edit-mode"
                                        transform="translate(-183.000000, -454.000000)"
                                      >
                                        <g
                                          id="facebook-logo-in-circular-button-outlined-social-symbol"
                                          transform="translate(183.000000, 454.000000)"
                                          fill="#000000"
                                          fillOpacity="0.38"
                                        >
                                          <path
                                            d="M22,11 C22,4.92498039 17.0749837,0 11,0 C4.92498039,0 0,4.92498039 0,11 C0,17.0749837 4.92498039,22 11,22 C17.0749837,22 22,17.0749837 22,11 Z M0.999993464,11 C0.999993464,5.47699346 5.47699346,0.999993464 11,0.999993464 C16.5230065,0.999993464 21.0000065,5.47699346 21.0000065,11 C21.0000065,16.5230065 16.5230065,21.0000065 11,21.0000065 C5.47699346,21.0000065 0.999993464,16.5230065 0.999993464,11 Z"
                                            id="Shape"
                                            fillRule="nonzero"
                                          />
                                          <path
                                            d="M11.4222101,18 L11.4222101,11.4912845 L13.5458869,11.4912845 L13.8814248,9.33436519 L11.4222101,9.33436519 L11.4222101,8.2528284 C11.4222101,7.69002242 11.6046643,7.15282869 12.4034618,7.15282869 L14,7.15282869 L14,5 L11.7334062,5 C9.82767605,5 9.30764325,6.26911422 9.30764325,8.02832513 L9.30764325,9.33337019 L8,9.33337019 L8,11.4912845 L9.30764325,11.4912845 L9.30764325,18 L11.4222101,18 Z"
                                            id="Path"
                                          />
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                </a>
                              </span>
                            ) : (
                                ""
                              )} */}
                              {data.emailid ? <Email data={data} /> : ""}
                              {/* {data.twitterurl ? (
                              <div className="dir-emp-links">
                                <a
                                  href={data.twitterurl}
                                  target="_blank"
                                  replace="true"
                                  className="social-icon"
                                >
                                  <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1">
                                    <g
                                      id="Page-1"
                                      stroke="none"
                                      strokeWidth="1"
                                      fill="none"
                                      fillRule="evenodd"
                                    >
                                      <g
                                        id="Final-emp_profile_edit-mode"
                                        transform="translate(-217.000000, -454.000000)"
                                      >
                                        <g
                                          id="Group-18"
                                          transform="translate(217.000000, 454.000000)"
                                          fill="#000000"
                                          fillOpacity="0.38"
                                        >
                                          <path
                                            d="M16.6764034,9.56177353 C16.6764034,9.46338563 16.674194,9.36588985 16.6687101,9.26928618 C17.1900373,8.95551545 17.642204,8.56288783 18,8.11351512 C17.5214789,8.28725515 17.007845,8.40335797 16.4678567,8.452074 C17.0188128,8.1781937 17.4413506,7.7403548 17.6410993,7.2147697 C17.1252561,7.46736661 16.5545736,7.64817987 15.9476342,7.74213904 C15.4614593,7.29541082 14.7678425,7.01092068 14.0006464,7.00027898 C12.5278005,6.98077983 11.3337268,7.98587849 11.3337268,9.24532644 C11.3337268,9.42435545 11.3567672,9.59809548 11.4028479,9.76559069 C9.18482044,9.65037999 7.21921101,8.7179571 5.90437287,7.31226548 C5.67499522,7.64907199 5.54330231,8.04259172 5.54330231,8.46449993 C5.54330231,9.26221296 6.01413011,9.97125581 6.72968265,10.3895955 C6.2917978,10.3736649 5.88133253,10.2664195 5.52136664,10.0908952 C5.52136664,10.1006448 5.52136664,10.1103944 5.52136664,10.120144 C5.52136664,11.2351643 6.44108659,12.1693396 7.6614751,12.3873669 C7.43758137,12.4387593 7.20161513,12.4653636 6.9590603,12.4645033 C6.78677062,12.4636112 6.6199254,12.4485408 6.45749888,12.4201523 C6.79663378,13.3339681 7.78220018,14.0013682 8.94881475,14.0235118 C8.0356834,14.6350589 6.88552058,15.000222 5.63656835,14.9975775 C5.4214331,14.9975775 5.20854666,14.9860756 5,14.9647922 C6.18093588,15.618906 7.58241201,15.9999998 9.08926615,15.9999998 C13.9940578,16.0009238 16.6764034,12.5531098 16.6764034,9.56177353 Z"
                                            id="Path"
                                          />
                                          <path
                                            d="M22,11 C22,4.92498039 17.0749837,0 11,0 C4.92498039,0 0,4.92498039 0,11 C0,17.0749837 4.92498039,22 11,22 C17.0749837,22 22,17.0749837 22,11 Z M1,11 C1,5.47699707 5.47699707,1 11,1 C16.5230029,1 21,5.47699707 21,11 C21,16.5230029 16.5230029,21 11,21 C5.47699707,21 1,16.5230029 1,11 Z"
                                            id="Shape"
                                            fillRule="nonzero"
                                          />
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                </a>
                              </div>
                            ) : (
                                ""
                              )} */}
                            </div>
                          </div>
            }
                        </Grid>
                      </Grid>
                    </Grid>
                    <Divider />
                  </div>
                );
              })
            ) : (
              <div
                style={{ height: "77vh" }}
                className="position-rel margin-top-16"
              >
                <DefaultComp
                  //  text={this.getText()}
                  heading={
                    this.props.filterid == 1
                      ? "There is no one reporting to you"
                      : this.props.filterid == 2
                      ? "You are a one person team"
                      : this.props.filterid == 3
                      ? "There is no one in your department"
                      : "This list seems to be empty"
                  }
                  subheading={
                    this.props.filterid == 1
                      ? "You will see your reportees once assigned"
                      : this.props.filterid == 2
                      ? "You will see your team members once they are added"
                      : this.props.filterid == 3
                      ? "You will see your department members once they are added"
                      : "You will be able to view the directory once your profile has been completely setup."
                  }
                  imageSrc={defaultstateimg}
                />
              </div>
            )}
          </div>
        </If>

        <Dialog
          fullWidth={true}
          maxWidth="lg"
          open={this.state.isloading}
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
          aria-labelledby="max-width-dialog-title"
        >
          <CustomLoader />
        </Dialog>
      </div>
    );
  }
}

EmpDirectoryDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(
  withSnackbar(EmpDirectoryDetails),
);
